import { Component, computed, ElementRef, inject, model, signal, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '@/layout/service/layout.service';
import { AppBreadcrumb } from './app.breadcrumb';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RippleModule } from 'primeng/ripple';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { AvatarModule } from 'primeng/avatar';
import { StorageService } from '@/core/service/utils/storage.service';
import { LOGGED_USER } from '@/core/constants/app-constants';

interface NotificationsBars {
    id: string;
    label: string;
    badge?: string | any;
}

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppBreadcrumb, InputTextModule, ButtonModule, IconFieldModule, InputIconModule, RippleModule, BadgeModule, OverlayBadgeModule, AvatarModule],
    template: `<div class="layout-topbar">
        <div class="topbar-left">
            <a tabindex="0" #menubutton type="button" class="menu-button" (click)="onMenuButtonClick()">
                <i class="pi pi-chevron-left"></i>
            </a>
            <img class="horizontal-logo" src="/layout/images/logo-white.svg"  />
            <span class="topbar-separator"></span>
            <div app-breadcrumb></div>
            <img class="mobile-logo" src="/layout/images/logo-{{ isDarkTheme() ? 'white' : 'dark' }}.svg"  />
        </div>

        <div class="topbar-right">
            <ul class="topbar-menu">
                <li class="profile-item static sm:relative">
                    <a class="flex items-center gap-1.5 px-3 py-2 cursor-pointer rounded-lg hover:bg-emphasis transition-colors duration-150 label-small dark:text-surface-400"
                        pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveActiveClass="animate-fadeout" leaveToClass="hidden" [hideOnOutsideClick]="true">
                        <i class="pi pi-link"></i>
                        <span>Link Utili</span>
                        <i class="pi pi-chevron-down text-xs"></i>
                    </a>
                    <div class="list-none p-2 m-0 rounded-2xl border border-surface overflow-hidden absolute bg-surface-0 dark:bg-surface-900 hidden origin-top w-52 mt-2 right-0 z-[999] top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]">
                        <ul class="flex flex-col gap-1">
                            <li>
                                <a href="https://erf-sima.it/" target="_blank" rel="noopener noreferrer"
                                    class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                                    <i class="pi pi-external-link"></i>
                                    <span>ERF - SIMA</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
                <li class="profile-item static sm:relative">
                    <a class="right-sidebar-button relative z-50" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveActiveClass="animate-fadeout" leaveToClass="hidden" [hideOnOutsideClick]="true">
                        <!-- Avatar con iniziali -->
                        <p-avatar
                        *ngIf="getInitials()"
                        styleClass="!w-10 !h-10 !text-[var(--p-surface-0)] !bg-[var(--p-primary-500)]"
                        shape="circle"
                        [label]="getInitials()">
                        </p-avatar>

                        <!-- Avatar immagine di fallback -->
                        <p-avatar
                        *ngIf="!getInitials()"
                        styleClass="!w-10 !h-10">
                        <img src="/layout/images/profile.jpg" />
                        </p-avatar>
                    </a>
                    <div
                        class="list-none p-2 m-0 rounded-2xl border border-surface overflow-hidden absolute bg-surface-0 dark:bg-surface-900 hidden origin-top w-52 mt-2 right-0 z-[999] top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
                    >
                        <ul class="flex flex-col gap-1">
                            <li>
                                <a routerLink="/profilo"
                                    class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                                    <i class="pi pi-user"></i>
                                    <span>Profilo</span>
                                </a>
                            </li>
                            <li>
                                <a class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer" (click)="logout()">
                                    <i class="pi pi-power-off"></i>
                                    <span>Log out</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>`
})
export class AppTopbar {

    constructor(private storage: StorageService, private router: Router) { }

    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());

    @ViewChild('menubutton') menuButton!: ElementRef;

    notificationsBars = signal<NotificationsBars[]>([
    ]);

    notifications = signal<any[]>([
    ]);

    selectedNotificationBar = model();

    selectedNotificationsBarData = computed(() => this.notifications().find((f) => f.id === this.selectedNotificationBar()).data);

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    showRightMenu() {
        this.layoutService.toggleRightMenu();
    }

    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }

    toggleSearchBar() {
        this.layoutService.layoutState.update((value) => ({ ...value, searchBarActive: !value.searchBarActive }));
    }

    getInitials() {
        const stored = this.storage.getItemLocal(LOGGED_USER);
        if (!stored) return '';

        try {
            const user = JSON.parse(stored);
            const nome = user?.nome?.charAt(0) ?? '';
            const cognome = user?.cognome?.charAt(0) ?? '';
            return (nome + cognome).toUpperCase();
        } catch {
            return '';
        }
    }

    logout() {
        if (this.storage.hasItemLocal(LOGGED_USER)) {
            this.storage.removeItemLocal(LOGGED_USER);
            this.storage.removeItemSession(LOGGED_USER);
            this.router.navigate(['auth/login']);
        }
    }
}
